"use client";

import React, { useEffect, useRef, useState } from "react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
const logos = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/partner_logo_dwp.png",
  alt: "Department for Work and Pensions"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/partner_logo_homes_england.png",
  alt: "Homes England"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/partner_logo_sanctuary.png",
  alt: "Sanctuary Housing Association"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/partner_logo_lq.png",
  alt: "L&Q Group"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/partner_logo_clarion.png",
  alt: "Clarion Housing Group"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/partner_logo_riverside.png",
  alt: "The Riverside Group"
}];
const stats = [{
  id: 1,
  value: 10,
  suffix: "%",
  label: "Target Net Yield"
}, {
  id: 2,
  prefix: "£",
  value: 150,
  suffix: "M+",
  label: "Assets Under Management"
}, {
  id: 3,
  value: 10,
  suffix: "Yrs",
  label: "Minimum Lease Security"
}];
interface AnimatedNumberProps {
  value: number;
  prefix?: string;
  suffix?: string;
  duration?: number;
}
function AnimatedNumber({
  value,
  prefix = "",
  suffix = "",
  duration = 2500
}: AnimatedNumberProps) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    let startTimestamp: number | null = null;
    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      setCount(Math.floor(easeProgress * value));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }, [isVisible, value, duration]);
  return <span ref={ref}>
      {prefix}
      {count}
      {suffix}
    </span>;
}
export default function EstablishedTrust() {
  return <section data-section-id="140342" id="our-credibility-partners" className="bg-background py-24 lg:py-32 overflow-hidden border-y border-primary/30">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        
        {}
        <div className="mb-24 lg:mb-32">
          <p className="text-center text-xs md:text-sm font-default font-semibold tracking-[0.2em] text-muted-foreground uppercase mb-10">
            Accredited by leading UK Housing Associations and Regulatory Bodies
          </p>
          
          <Carousel opts={{
          align: "start",
          loop: true,
          dragFree: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-8 items-center">
              {logos.map((logo, i) => <CarouselItem key={logo.id} data-index={i} className="pl-4 md:pl-8 basis-1/2 md:basis-1/3 lg:basis-1/5">
                  <div className="flex h-20 items-center justify-center p-4 group">
                    <img src={logo.src} alt={logo.alt} className="max-h-12 w-auto object-contain filter grayscale opacity-50 transition-all duration-500 ease-in-out group-hover:grayscale-0 group-hover:opacity-100" />
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>
        </div>

        {}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 divide-y md:divide-y-0 md:divide-x divide-border/50">
            {stats.map((stat, i) => <div key={stat.id} data-index={i} className="flex flex-col items-center justify-center text-center pt-12 md:pt-0 first:pt-0">
                <div className="text-6xl lg:text-7xl font-default font-light tracking-tighter text-primary mb-4">
                  <AnimatedNumber value={stat.value} prefix={stat.prefix} suffix={stat.suffix} />
                </div>
                <h3 className="text-sm font-default font-medium tracking-[0.15em] uppercase text-muted-foreground">
                  {stat.label}
                </h3>
              </div>)}
          </div>
        </div>

      </div>
    </section>;
}